import { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { useForm } from 'react-hook-form';

import { DEFAULT_PASSWORD_POLICY, getDefaultPasswordPolicy } from '../../../services/PasswordPolicies';
import { activateNewUser } from '../../../services/Users';

import { useAppContext } from '../../../contexts/app';
import { acceptLegalByToken, getLegalTemplateByToken } from '../../../services/Legal';

const useActivateNewUser = () => {
  const navigateRedirect = useNavigate();

  const { token } = useParams();

  const [openLegal, setOpenLegal] = useState(false);
  const [legalHtml, setLegalHtml] = useState(null);

  const { blockScreen, handleAlert } = useAppContext();

  const formMethods = useForm({
    defaultValues: {
      password: '',
      acceptedDataProcessing: false,
    },
  });

  const [passwordPolicies, setPasswordPolicies] = useState(DEFAULT_PASSWORD_POLICY);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => formMethods.reset(), []);

  const handleHome = () => navigateRedirect('/');

  const initComponent = async () => {
    blockScreen(true);
    formMethods.reset();
    try {
      const policies = await getDefaultPasswordPolicy();
      setPasswordPolicies({
        ...DEFAULT_PASSWORD_POLICY,
        ...policies,
      });
    } catch (error) {
      handleAlert(error, 'error');
    } finally {
      blockScreen(false);
    }
  };

  const handleRedirectHome = () => {
    setTimeout(() => {
      setOpenLegal(false);
      handleHome();
    }, 1000);
  };

  const handleCloseLegalTemplate = () => {
    setOpenLegal(false);
    handleHome();
  };

  const acceptLegalTemplate = async () => {
    blockScreen(true);
    try {
      await acceptLegalByToken(token);
      handleAlert('Terms and Conditions accepted succefully!', 'success');
      handleRedirectHome();
    } catch (error) {
      handleAlert(error, 'error');
    } finally {
      blockScreen(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { initComponent(); }, []);

  const handleOnSubmit = async (data) => {
    blockScreen(true);

    try {
      await activateNewUser(token, data);

      formMethods.reset();
      handleAlert('User activated succefully!', 'success');

      const template = await getLegalTemplateByToken(token);
      setLegalHtml(template);
      setOpenLegal(true);
    } catch (error) {
      handleAlert(error, 'error');
    } finally {
      blockScreen(false);
    }
  };

  return {
    formMethods,
    passwordPolicies,
    handleHome,
    handleOnSubmit,

    openLegal,
    legalHtml,
    acceptLegalTemplate,
    handleCloseLegalTemplate,
  };
};

export default useActivateNewUser;
